import React from 'react';
import Button from '../button';
import styled from 'styled-components';

const LogoContainer = styled.div`
    background-image: url(${props => props.logo});
`
const BannerContainer = styled.div`
background-image: url(${props => props.banner});
`

const Banner = (props) => {

    return (
        <div className="banner-container">
            <div className="color-column">
                <LogoContainer logo={props.config.logo} className="company-logo"/>
                <hr className="gold-line"/>
                <div className="banner-text">
                    Check your <div className="gold-gradient">Personalized Loan Offers</div> <span
                    className="break-desktop">with Multiple
                    Lending Partners in Under 2 Minutes!</span>
                </div>
                <Button
                    buttonText={"Check Loan Offers"}
                    buttonColorBg={"transparent"}
                    arrowColor={'#068599'}
                    buttonHoverColor={"#F0C17D"}
                    fontColor={"#F0C17D"}
                    fontHoverColor={"#fff"}
                    fontSize={'18px'}
                    buttonWidth={'280px'}
                    buttonHeight={'60px'}
                    buttonBorderWidth={'2px'}
                    linkTarget={'_self'}
                    linkDestination={"#start-loan"}
                />
                <div className="button-subtext">
                    wont affect your credit score!*
                </div>
            </div>
            <BannerContainer banner={props.config.banner_image} className="image-column"/>
            <div className="banner-numbers">
                <div>01</div>
                <div>02</div>
                <div>03</div>
            </div>
        </div>
    )

}

export default Banner;
